module.exports = __webpack_public_path__ + "static/img/product_banner_47_zh.fe213eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_47_zh.png
// module id = k7HV
// module chunks = 34